import moment from 'moment';
import type { AppDispatch } from 'modules/app/components/App';

import { getNewDate, displayDate } from 'utils/date';
import { downloadAsCsvFile } from 'utils/csv';
import { addPositiveToast, addNegativeToastWithErrorId } from 'modules/toastContainer';

import { getWorkflows as fetchWorkflows } from 'api/ReportingAPI';

import { LegacyWorkflow } from '../types';
import {
  WORKFLOW_CSV_DATA_DATE_FORMAT,
  WORKFLOW_CSV_FILENAME_DATE_FORMAT,
  WORKFLOW_CSV_FILENAME_PREFIX,
  WORKFLOW_CSV_HEADER_ROW,
} from '../constants';

const displayText = {
  enabled: 'Enabled',
  disabled: 'Disabled',
  success: 'Successfully exported journeys',
  failed: 'Unable to export CSV',
};

const getWorkflows = async () =>
  (
    await fetchWorkflows({
      page: 1,
      orderBy: 'id',
      sorting: 'desc',
      filter: null,
      archived: false,
    })
  ).data.workflows;

/**
 * Converts workflows into arrays of CSV cell values. Cells correspond
 * to columns defined by `WORKFLOW_CSV_HEADER_ROW`.
 */
const getRowsForWorkflows = (workflows: LegacyWorkflow[]) =>
  workflows.map((workflow) => [
    workflow.id,
    workflow.name,
    moment(workflow.createdAt).format(WORKFLOW_CSV_DATA_DATE_FORMAT),
    moment(workflow.updatedAt).format(WORKFLOW_CSV_DATA_DATE_FORMAT),
    workflow.steps,
    workflow.started,
    workflow.inProgress,
    workflow.finished,
    workflow.enabled ? displayText.enabled : displayText.disabled,
    workflow.creatorUserId,
    workflow.isArchived.toString(),
  ]);

export const exportWorkflowsToCsv = async (dispatch: AppDispatch) => {
  try {
    const workflows = await getWorkflows();
    const rows = [WORKFLOW_CSV_HEADER_ROW, ...getRowsForWorkflows(workflows)];
    const fileName = `${WORKFLOW_CSV_FILENAME_PREFIX}${displayDate(
      getNewDate(),
      WORKFLOW_CSV_FILENAME_DATE_FORMAT,
    )}.csv`;
    downloadAsCsvFile({ rows, fileName });
    dispatch(addPositiveToast(displayText.success));
  } catch (e) {
    dispatch(addNegativeToastWithErrorId(displayText.failed, 'exportWorkflowsToCsv'));
  }
};
